<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Brand logo-->
      <b-link href="https://www.taobao2you.com" class="brand-logo" >
        <!-- <vuexy-logo /> -->
        <b-img
          class="d-none d-sm-block"
          :src="require('@/assets/logo-taobao/Profile.jpg')"
          fluid
          width="50px"
          height="30px"
        >
        </b-img>
        <h2 class="brand-text text-primary ml-1 mt-1 d-none d-sm-block">
          TAOBAO2YOU
        </h2>
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-0">
          <b-img
            style="width:100%"
            fluid
            :src="require('@/assets/taobao2you+no1.png')"
            alt="Login taobao"
          />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <b-card-title
            class="mb-1 font-weight-bold"
            title-tag="h2"
          >
          <b-img
            class="d-block d-sm-none "
            style="width:100%"
            fluid
            :src="require('@/assets/taobao2you+no1.png')"
            alt="Login taobao"
          />
            <!-- เข้าสู่ระบบ Tracking -->
            登录运单号系统
          </b-card-title>

          <!-- form -->
          <validation-observer
            ref="loginForm"
            #default="{invalid}"
          >
            <b-form
              class="auth-login-form mt-2"
              @submit.prevent="loginButton"
            >
              <!-- email -->
              <!-- เบอร์โทรศัพท์ -->
              <b-form-group
                label="电话"
                label-for="login-phone"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Phone"
                  vid="phone"
                  rules="required"
                >
                  <b-form-input
                    id="login-phone"
                    v-model="phone"
                    :state="errors.length > 0 ? false:null"
                    name="login-phone"
                    placeholder="电话"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- submit buttons -->
              <b-button
                type="submit"
                variant="primary"
                block
                :disabled="invalid || loadButton == false"
                @click="loginButton()"
              >
                <b-spinner v-if="loadButton == false" small />
                <!-- เข้าสู่ระบบ -->
                登录系统
              </b-button>
            </b-form>
          </validation-observer>
        </b-col>
      </b-col>
    <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { taobaoService_dotnet   } from '@/views/global'
import axios from 'axios'
import { token_api, header_token } from '@/views/token'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BFormCheckbox,
  BCardText, BCardTitle, BImg, BForm, BButton, BAlert, VBTooltip, BCard, BSpinner
} from 'bootstrap-vue'
import useJwt from '@/auth/jwt/useJwt'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import { getHomeRouteForLoggedInUser } from '@/auth/utils'

export default {
  props:{
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    BAlert,
    BCard,
    VuexyLogo,
    ValidationProvider,
    ValidationObserver,
    BSpinner,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: '',
      password: 'admin',
      userEmail: 'admin@demo.com',
      sideImg: require('@/assets/images/pages/login-v2.svg'),

      // validation rules
      required,
      email,
      profile: [],
      phone: '',

      loadButton: true,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/login-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },

  methods: {
    async loginButton(){
      this.loadButton = await false
      var sToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MSwiaWF0IjoxNjQ1NDMxOTM3LCJleHAiOjE2NDU0MzI1Mzd9.GAO0TlWsHDaP_KImlaG6MomhnomjHj5xTWMkrfoNUmw"
      var rToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MSwiaWF0IjoxNjQ1NDMxOTM3LCJleHAiOjE2NDU0MzI1Mzd9.FoUDDNh6hBlWHtHKsagslOFU20v9aYVAhDX9SqKAajE"
      // var abi = [{action: "read", subject: "dashboard"}]
      this.profile = []
    //   let response = await axios.post(taobaoService_dotnet  + 'app/Customer/login', {
    let response = await axios.post(taobaoService_dotnet  + 'China/login-by-phone', {
        "username": "",
        "password": "",
        "phoneNumber": this.phone
      },
      { headers: {'Content-Type': 'application/json', 'Authorization': 'Bearer '+ token_api }})
      this.$refs.loginForm.validate().then( async success => {
        if( response.data.status == 'success' ) {
          if (success) {
            await this.profile.push({
              'data': response.data,
              'role': 'tracking',
              'ability': [
                {action: "manage", subject: "TaobaoTracking"},
              ]
            })
            // useJwt.setToken(sToken)
            // useJwt.setRefreshToken(rToken)
            localStorage.setItem('userInfo', JSON.stringify(this.profile[0]))
            this.$ability.update(this.profile[0].ability)

            this.$store.commit('app-ecommerce/UPDATE_CART_ITEMS_COUNT', 0)

            this.$router.replace(getHomeRouteForLoggedInUser(this.profile[0].role))

            this.loadButton = true

          }
        } else {
          this.$swal({
            position: 'top',
            title: '登陆失败!', //ล็อคอินไม่สำเร็จ
            text: response.data.error_description,
            icon: 'warning',
            confirmButtonText: '确认',
            customClass: {
              confirmButton: 'btn btn-primary',
              text: 'text-danger'
            },
            buttonsStyling: false,
          })
          this.loadButton = true
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
<style>

</style>
